module.exports = __webpack_public_path__ + "img/MW_Groups_FB_Instructions_1.5c536cd3.gif";